<template>
  <div class="member">
    <div class="content">
      <!--<div class="adminlist-wrapper">-->
        <!--<section class="top">{{$t('m.school_m_admin_list')}}</section>-->
        <!--<section class="bottom">-->
          <!--<template v-for="(item,index) in adminList">-->
            <!--<div class="list">-->
              <!--<div class="img-wrapper">-->
                <!--<img :src="computeUrl(item.headimg)" alt="avatar" width="100" height="100">-->
                <!--<span class="close"-->
                      <!--v-if="!item.iscreator&&(schoolNow.iscreator||schoolNow.ismanager)"-->
                      <!--@click="confirmDelAdmin(item.userid)"></span>-->
              <!--</div>-->
              <!--<div class="text-wrapper">-->
                <!--<p class="name">{{decodeURIComponent(item.name)}}</p>-->
                <!--<p class="identity" v-if="item.iscreator">{{$t('m.school_m_founder')}}</p>-->
                <!--<p class="identity" v-else>{{$t('m.school_m_administrator')}}</p>-->
              <!--</div>-->
            <!--</div>-->
          <!--</template>-->
          <!--<div class="list" v-if="!isEmpty(adminList)&&adminList.length<8&&(schoolNow.iscreator||schoolNow.ismanager)"-->
               <!--@click="showAddAdmin">-->
            <!--<img src="./add.png" alt="add" width="100" height="100">-->
          <!--</div>-->
        <!--</section>-->
      <!--</div>-->
      <div class="teacherlist-wrapper">
        <section class="top">{{$t('m.school_m_teacher_list')}}
          <button class="add-teacher"
                  @click="showTeacherQR"
                  v-if="schoolNow.iscreator||schoolNow.ismanager">{{$t('m.school_m_invite_teacher')}}
          </button>
        </section>
        <section class="bottom">
          <template v-for="(item,index) in teacherList">
            <div class="list">
              <div class="img-wrapper">
                <img :src="computeUrl(item.faceimg)" alt="avatar" width="180" height="180">
                <span class="corner" v-if="isAdmin(item.userid)"></span>
              </div>
              <div class="text-wrapper">
                <p class="name">{{decodeURIComponent(item.teachername)}}</p>
                <p class="type">{{decodeURIComponent(item.typename)}}</p>
                <p class="score">{{$t('m.school_m_score')}}
                  <el-rate
                    class="star"
                    v-model="item.score"
                    disabled
                    show-score
                    text-color="#ff9900"
                    score-template="{value}">
                  </el-rate>
                </p>
                <div class="btn-wrapper"
                     @mouseenter="item.show=true"
                     @mouseleave="item.show=false"
                     v-if="schoolNow.iscreator||schoolNow.ismanager">
                  <button class="btn">{{$t('m.school_m_opetate')}}</button>
                  <ul class="ul" v-if="item.show">
                    <!--<li class="li"-->
                        <!--@click="addToAdmin(item.userid)"-->
                        <!--v-if="!isAdmin(item.userid)">{{$t('m.school_m_set_administrator')}}-->
                    <!--</li>-->
                    <li class="li" @click="showModifyTeacher(item)">{{$t('m.school_m_modify_information')}}</li>
                    <!--<li class="li color"-->
                        <!--v-if="!isCreate(item.userid)"-->
                        <!--@click="confirmDelTeacher(item.userid)">{{$t('m.school_m_delete_teacher')}}-->
                    <!--</li>-->
                  </ul>
                </div>
              </div>
            </div>
          </template>
        </section>
      </div>
    </div>
    <div class="addteacher-mask" v-if="teacherQRShow">
      <div class="addteacher">
        <img class="close" @click="teacherQRShow=false" src="./close.png" alt="close" width="20" height="20">
        <h2 class="title">{{$t(inviteText)}}</h2>
        <img :src="teacherUrl" alt="QRcode" width="300" height="300">
        <p class="explain">{{$t('m.wechat_share')}}</p>
      </div>
    </div>

    <div class="warePop" v-if="addAdminShow">
      <div class="ware-content-wrapper">
        <h3 class="ware-title">{{$t('m.school_m_settobe_admin')}}</h3>
        <div class="flex-wrapper">
          <p class="left">{{$t('m.school_m_chose')}} {{count}}{{$t('m.school_m_chose2')}}</p>
          <p class="right" @click="inviteAdmin">{{$t('m.school_m_invite_admin')}}</p>
        </div>
        <div class="ware-wrapper">
          <template v-for="(item,index) in teacherList">
            <div class="classware">
              <div style="display: inline-block;width:60px;height:60px;vertical-align: top">
                <img class="cover" :src="computeUrl(item.faceimg)" alt="cover" width="60" height="60">
              </div>
              <div class="classware-middle">
                <h3 class="title">{{decodeURIComponent(item.teachername)}}</h3>
                <p class="introduce">{{decodeURIComponent(item.typename)}}</p>
              </div>
              <img v-if="item.addshow===false"
                   @click="show(item,index)"
                   class="del"
                   src="./beforeSelect.png"
                   alt="delete-button" width="20"
                   height="20">
              <img v-if="item.addshow===true"
                   @click="notShow(item,index)"
                   class="del"
                   src="./selected.png"
                   alt="delete-button" width="20"
                   height="20">
            </div>
          </template>
        </div>
        <div class="ware-btn-outside">
          <div class="ware-btn-inside">
            <button class="cancel" @click="addAdminShow=false;">{{$t('m.cancel')}}</button>
            <button class="confirm" @click="addAdmins">{{$t('m.confirm')}}</button>
          </div>
        </div>
      </div>
    </div>
    <div class="classpop-mask" v-if="modifyShow">
      <div class="classpop">
        <h2 class="title">{{$t('m.modify_information')}}</h2>
        <div class="cover-row">
          <span class="left">{{$t('m.school_m_avatar')}}</span>
          <span class="right">
            <span class="img-wrapper">
              <img class="img" :src="imgurl" alt="cover" width="100" height="100">
            </span>
            <div class="upload-button-wrapper">
              <vue-core-image-upload
                class="upload-button"
                crop="local"
                text="选择本地图片"
                :cropBtn="{ok:'确定','cancel':'取消'}"
                cropRatio="1:1"
                @imageuploaded="imageuploaded"
                :max-file-size="5242880"
                :url="imgUpUrl">
                </vue-core-image-upload>
            </div>
          </span>
        </div>
        <p class="row">
          <span class="left">{{$t('m.school_m_name')}}</span>
          <input type="text" class="input-name" v-model="teacherName" maxlength="10">
        </p>
        <p class="row">
          <span class="left">{{$t('m.school_m_sex')}}</span>
          <select name="sex" id="sex" class="type-select" v-model="sex">
            <option value="男">男</option>
            <option value="女">女</option>
          </select>
        </p>
        <p class="row">
          <span class="left">{{$t('m.school_m_type')}}</span>
          <el-cascader
            :options="firstType"
            v-model="selectedOptions"
            size="small">
          </el-cascader>
        </p>
        <div class="split"></div>
        <div class="add-introduce">
          <span class="left">{{$t('m.school_m_personal_introduce')}}</span>
          <div class="right">
            <template v-for="(item,index) in introduceList">
              <div class="text-wrapper" v-if="item.isImage===false">
                <textarea class="text" v-model='item.text' name="text" cols="30" rows="10"></textarea>
                <img class="img" @click="del(index)" src="./delete.png" alt="delete-button" width="24" height="24">
              </div>
              <div class="img-wrapper" v-if="item.isImage===true">
                <div class="img-left">
                  <img class='showimg' :src="introduceImgUrl(item)" alt="img" width="100" height="100"><input
                  class="input" type="file" accept="image/*" @change="upImg(index,$event)"/>
                </div>
                <img class="img" @click="del(index)" src="./delete.png" alt="delete-button" width="24" height="24">
              </div>

            </template>
            <button class="add" @click="addText">{{$t('m.addtext')}}</button>
            <button class="add" @click="addImage">{{$t('m.addimg')}}</button>
          </div>
        </div>
        <div class="example">
          <span class="left">参考样式：</span>
          <div class="example-area">
            <p>老师个人介绍：<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本人从事教育教学工作XX年，有多年的带班经验和教研工作经验。我多次获得市级教学能手、模范教师和模范班主任荣誉称号，在学校中担任学科负责人、教研组组长等职务。<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我擅长英语阅读理解、写作及语法方面的知识点教学，所带学生多次在英语演讲比赛和知识竞赛中获得奖项，历届学生成绩都非常优秀。针对考试成绩不理想的同学，经过我一对一针对性的补习短期内成绩提分20＋。<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在课堂上，我会营造风趣幽默氛围，轻松活泼，旨在寓教于乐，深得学生和家长的喜爱。
            </p>
            <div style="display: flex; justify-content: space-evenly; align-items: center">
              <img src="./example01.png" alt="" width="150">
              <img src="./example02.png" alt="" width="200">
            </div>
          </div>
        </div>
        <div class="operate-btn-wrapper">
          <button class="btn cancel" @click="modifyShow=false">{{$t('m.cancel')}}</button>
          <button class="btn confirm" @click="modifyTeacher">{{$t('m.save')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import Vue from 'vue';
  import {saveLocal, loadLocal} from 'common/js/store.js';
  import VueCoreImageUpload from 'vue-core-image-upload';
  export default{
    data(){
      return {
        id: (() => loadLocal('id', false))(),
        schoolNow: (() => loadLocal('schoolNow', false))(),
        imgprefix: (() => loadLocal('imgprefix', false))(),
        adminList: [],               //管理员列表
        teacherList: [],             //老师列表
        //--------------添加管理员---------------------//
        count: 0,
        addAdminShow: false,
        //-----------邀请老师的二维码--------------------//
        inviteText: 'm.school_m_invite_teacher',
        teacherUrl: '',
        teacherQRShow: false,
        //----------以下内容和修改老师资料有关-------------//
        modifyShow: false,
        teacheruserid: '',
        imgUpUrl: '',              //该url是组件‘vue-core-image-upload’上传的url地址（带sessionid）
        imgurl: require('./avatar.png'),
        upurl: '',
        teacherName: '',             //老师名字
        sex: '',                      //老师性别
        selectedOptions: [],      //表示选中的选项
        firstType: [],
        secondType: [],
        introduceList: [],           //老师的图文介绍
        index: 0,        //根据上传图片确定index，从而对相应的list[this.index]赋值
      }
    },
    methods: {
      isEmpty(obj){
        for (let i in obj) {
          return !1;
        }
        return !0;
      },
      computeUrl(url){
        if (url === '') {
          return require('./avatar.png');
        } else {
          return this.imgprefix + url;
        }
      },
      showAddAdmin(){
        this.addAdminShow = true;
        this.count = 0;
        this.teacherList.forEach(function (ele) {
          ele.addshow = false;
        })
      },
      show(item, index){
        Vue.set(this.teacherList[index], 'addshow', true);
        this.count++;
        this.$forceUpdate();
      },
      notShow(item, index){
        Vue.set(this.teacherList[index], 'addshow', false);
        this.count--;
        this.$forceUpdate();
      },
      //将校内老师添加成为管理员（列表添加）
      addAdmins(){
        let nums = 0;
        for (let i = 0; i < this.teacherList.length; i++) {
          if (this.teacherList[i].addshow === true) {
            //接口：添加网校管理员
            this.$http({
              url: '/indexapp.php',
              method: 'GET',
              params: {
                c: 'Room',
                a: 'AddRoomManager',
                id: this.id,
                rid: this.schoolNow.rid,
                teacheruserid: this.teacherList[i].userid,
              }
            }).then((response) => {
              response = response.data;
              if (response.code === 111) {
                this.$router.push({path:'/log',query:{url:this.$getUrl.getUrl()}});
              }
              if (response.success === true) {
                nums++;
                if (nums === this.count) {
                  this.addAdminShow = false;
                  this.$message({
                    message: '添加成功',
                    type: 'success',
                  })
                }
              }
//              if (response.code === 200) {
//                nums++;
//                if(nums===this.count){
//                  this.addAdminShow=false;
//                  this.$message({
//                    message:'添加成功',
//                    type:'success',
//                  })
//                }
//              }
            }).catch((err) => {
              this.$alert('未获取到数据，请重新加载页面', '提示', {
                confirmButtonText: '刷新',
                callback: action => {
                  window.location.reload();
                }
              });
            });
          }
        }
      },
      //邀请校外人员成为管理员
      inviteAdmin(){
        this.inviteText = 'm.school_m_invite_admin';
        this.addAdminShow = false;
        this.teacherQRShow = true;
        this.teacherUrl = '';
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'Room',
            a: 'GetInviteRoomMangerShareUrl',
            ownerid: this.id,
            rid: this.schoolNow.rid,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 200) {
            let url = encodeURIComponent(response.url);
            url = encodeURIComponent(url);
            let title = `${decodeURIComponent(this.schoolNow.roomname)}网校邀请您成为该网校的管理员`;
            let subtitle = '接收邀请，成为管理员';
            let img = response.imgprefix + this.schoolNow.faceimg || response.shareimage;
            let finalUrl = response.homepath + `indexm.html#/share?title=${title}&subtitle=${subtitle}&img=${img}&url=${url}`;
            finalUrl = encodeURIComponent(finalUrl);
            this.teacherUrl = response.path + 'indexapp.php?c=QRCode&a=QRCode&url=' + finalUrl + '&size=6';
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      },
      //确认删除管理员
      confirmDelAdmin(userid){
        this.$confirm('确定删除该管理员吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.delAdmin(userid);
        }).catch(() => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      },
      //删除管理员
      delAdmin(userid){
        //接口：添加网校管理员
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'Room',
            a: 'DeleteRoomManager',
            id: this.id,
            rid: this.schoolNow.rid,
            deleteuserid: userid,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path:'/log',query:{url:this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.$message({
              message: '删除成功',
              type: 'success',
            });
            this.QueryRoomManagerList();
            this.$forceUpdate();
          }else{
            this.$message({
              message: response.msg,
              type: 'warning',
            });
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      },
      //显示邀请老师的二维码
      showTeacherQR(){
        this.inviteText = 'm.school_m_invite_teacher';
        this.teacherQRShow = true;
        this.teacherUrl = '';
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'Lesson',
            a: 'InviteTeacher',
            id: this.id,
            rid: this.schoolNow.rid,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 200) {
            let url = encodeURIComponent(response.list[0].inviteurl);
            url = encodeURIComponent(url);
            let title = `${decodeURIComponent(this.schoolNow.roomname)}网校邀请您成为该网校的老师`;
            let subtitle = '接收邀请，成为老师';
            let img = response.imgprefix + this.schoolNow.faceimg || response.shareimage;
            let finalUrl = response.homepath + `mstudent/index.html#/share?title=${title}&subtitle=${subtitle}&img=${img}&url=${url}`;
            finalUrl = encodeURIComponent(finalUrl);
            this.teacherUrl = response.path + 'indexapp.php?c=QRCode&a=QRCode&url=' + finalUrl + '&size=6';
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      },
      //判断老师是否是管理员
      isAdmin(userid){
        if (this.isEmpty(this.adminList)) {
          return false;
        } else {
          for (let i = 0; i < this.adminList.length; i++) {
            if (userid == this.adminList[i].userid) {
              return true;
            }
          }
        }
      },
      //判断老师是否为创建者
      isCreate(userid){
        if (this.isEmpty(this.adminList)) {
          return false;
        } else {
          for (let i = 0; i < this.adminList.length; i++) {
            if (this.adminList[i].iscreator === 1 && this.adminList[i].userid === userid) {
              return true;
            }
          }
        }
      },
      //添加老师为管理员
      addToAdmin(userid){
        //接口：添加网校管理员
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'Room',
            a: 'AddRoomManager',
            id: this.id,
            rid: this.schoolNow.rid,
            teacheruserid: userid,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path:'/log',query:{url:this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.$message({
              message: '添加成功',
              type: 'success',
            });
            this.QueryRoomManagerList();
            this.$forceUpdate();
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      },
      //------------------------------以下内容和修改老师资料相关-----------------//
      //打开修改老师资料界面
      showModifyTeacher(item){
        this.imgurl = require('./avatar.png');
        this.upurl = '';
        this.modifyShow = true;
        this.teacheruserid = item.userid;
        this.teacherName = decodeURIComponent(item.teachername);
        this.sex = decodeURIComponent(item.sex);
        if (item.faceimg !== '') {
          this.imgurl = this.imgprefix + item.faceimg;
          this.upurl = item.faceimg;
        }
        if (item.introduce == '') {
          this.introduceList = [];
        } else {
          this.introduceList = JSON.parse(decodeURIComponent(item.introduce));
        }
        let array = [];
        if (item.maintype !== '') {
          array[0] = item.maintype + '';
          array[1] = item.subtype + '';
          this.selectedOptions = array;
        }
      },
      //删除添加文字、添加图片的某一项
      del: function (index) {
        this.introduceList.splice(index, 1);
        this.$forceUpdate()  // 迫使 Vue 实例重新渲染。
      },
      //增加文字、图片的相关方法
      addText(){
        let oText = {
          "isImage": false,
          "text": '',
        };
        this.introduceList.push(oText);
        this.$forceUpdate();
      },
      addImage(){
        let oText = {
          "isImage": true,
          "image": './addImage.png',
          "width": 0,
          "height": 0,
        };
        this.introduceList.push(oText);
        this.$forceUpdate();
      },
      introduceImgUrl(item){
        if (item.image == './addImage.png') {
          return require('./addImage.png');
        } else {
          return this.imgprefix + item.image;
        }
      },
      upImg: function (index, e) {
        this.index = index;
        let input = e.target;
        // 通过DOM取文件数据
        let file = input.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function (e) {
          let image = input.previousSibling;
          image.src = e.target.result;
        };
        let xhr = new XMLHttpRequest();
        //initiate request
        let url = '/indexapp.php?c=Upload&a=UploadFileNew&id=' + this.id;
        xhr.open('post', url, true);
        //set headers
        xhr.setRequestHeader('X-File-Name', encodeURI(file.name));
        xhr.setRequestHeader('X-File-Size', file.size);
        xhr.setRequestHeader('X-File-Type', file.type);
        xhr.addEventListener('load', this.uploadComplete, false);
        //send the file
        xhr.send(file);
      },
      uploadComplete: function (evt) {

        let response = evt.target.responseText;
        let jsonobj = JSON.parse(response);
        this.$set(this.introduceList[this.index], 'image', jsonobj.image);
        this.$set(this.introduceList[this.index], 'width', jsonobj.imagewidth);
        this.$set(this.introduceList[this.index], 'height', jsonobj.imageheight);
        this.$forceUpdate();

      },
      //VueCoreImageUpload上传后调用的方法
      imageuploaded(response) {
        if (response.code === 111) {
          this.$router.push({path:'/log',query:{url:this.$getUrl.getUrl()}});
        } else if (response.code === 200) {
          this.imgurl = response.imgprefix + response.image;
          this.upurl = response.image;
        }
      },
      //修改老师资料
      modifyTeacher(){
        if (this.upurl == '' || this.teacherName == '' || this.sex == '' || this.isEmpty(this.selectedOptions)) {
          return;
        }
        let url = '/indexapp.php?c=Teacher&a=UpdateRoomTeacherInfo';
        let params = new URLSearchParams();
        params.append('id', this.id);
        params.append('rid', this.schoolNow.rid);
        params.append('teacheruserid', this.teacheruserid);
        params.append('faceimg', this.upurl);
        params.append('teachername', this.teacherName);
        params.append('sex', this.sex);
        params.append('maintype', this.selectedOptions[0]);
        params.append('subtype', this.selectedOptions[1]);
        let introduce = this.computeUpIntroduceList(this.introduceList);
        params.append('introduce', introduce);
        let typename = '';
        for (let i = 0; i < this.firstType.length; i++) {
          if (this.firstType[i].id == this.selectedOptions[0]) {
            typename = this.firstType[i].name;
          }
        }
        for (let i = 0; i < this.secondType.length; i++) {
          if (this.secondType[i].id == this.selectedOptions[1]) {
            typename += '/' + this.secondType[i].name;
          }
        }
        params.append('typename', typename);

        this.$http({
          url: url,
          method: 'post',
          data: params,
        }).then((response) => {
          response = response.data;
          if (response.code === 200) {
            this.modifyShow = false;
            this.$message({
              message: '更新老师资料成功',
              type: 'success'
            });
            this.QueryTeachers();
            this.$forceUpdate();
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        })
      },
      //根据当前introduceList的值，返回相应的符合上传需求的数据
      computeUpIntroduceList(list){
        if (this.isEmpty(list)) {
          return '';
        } else {
          let result = [];
          for (let i = 0; i < list.length; i++) {
            if (list[i].isImage === true) {
              if (list[i].width === 0) {
                continue;
              }
            } else {
              if (list[i].text === '') {
                continue;
              }
            }
            result.push(list[i]);
          }
          if(this.isEmpty(result)){
            return '';
          }
          result = JSON.stringify(result);
          result = encodeURIComponent(result);
          return result;
        }
      },
      //删除老师按钮
      confirmDelTeacher(userid){
        this.$confirm('确定删除该老师吗??', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.delTeacher(userid);
        }).catch(() => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      },
      delTeacher(userid){
        //接口：更新网校老师资料（isdeleted:如果为1，则表示删除老师，默认为0）
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'Teacher',
            a: 'UpdateRoomTeacherInfo',
            id: this.id,
            rid: this.schoolNow.rid,
            teacheruserid: userid,
            isdeleted: 1
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path:'/log',query:{url:this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.$message({
              message: '删除成功',
              type: 'success',
            });
            this.QueryTeachers();
          }else{
            this.$message({
              message: response.msg,
              type: 'warning',
            });
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      },
      //获取管理员列表
      QueryRoomManagerList(){
        //接口：查询指定网校管理员列表
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'Room',
            a: 'QueryRoomManagerList',
            id: this.id,
            rid: this.schoolNow.rid,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path:'/log',query:{url:this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.adminList = response.list;
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      },
      QueryTeachers(){
        //接口：查询网校老师列表
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'Teacher',
            a: 'QueryTeachers',
            id: this.id,
            rid: this.schoolNow.rid,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path:'/log',query:{url:this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            let list = response.list;
            list.forEach(function (ele) {
              ele.show = false;
              ele.addshow = false;
            });
            this.teacherList = list;
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      },
      //将从服务器获取到的数据增加value字段和label字段
      nameOption(obj){
        for (let i = 0; i < obj.length; i++) {
          obj[i].value = obj[i].id;
          obj[i].label = obj[i].name;
        }
      },
      //将created中异步获取的分类列表合并为适合el-cascader的options
      mergeOption: function (first, second) {
        for (let j = 0; j < first.length; j++) {
          first[j].children = [];
          for (let k = 0; k < second.length; k++) {
            if (second[k].parentid == first[j].id) {
              first[j].children.push(second[k]);
            }
          }
        }
      },
      //获取课程的分类
      loadLessonType(){
        let i = 0;
        //获取第一大分类
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'Lesson',
            a: 'QueryLessonType',
            parentid: 0
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 200) {
            this.firstType = response.list;
            this.nameOption(this.firstType);
            i++;
            if (i === 2) {
              this.mergeOption(this.firstType, this.secondType);
            }
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });

        //获取第二大分类
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'Lesson',
            a: 'QueryLessonSecondType'
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 200) {
            this.secondType = response.list;
            this.nameOption(this.secondType);
            i++;
            if (i === 3) {
              this.mergeOption(this.firstType, this.secondType);
            }
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      },
    },
    created(){
      this.imgUpUrl = `${this.GLOBAL.uploadUrl}indexapp.php?c=Upload&a=UploadFileVue&id=` + this.id;
      //获取管理员列表
      this.QueryRoomManagerList();
      //获取教师列表
      this.QueryTeachers();
      //获取分类列表
      this.loadLessonType();
    },
    components: {
      VueCoreImageUpload,
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .member
    width: 100%
    height: 100%
    background: #f2f2f2
    font-size: 0
    overflow auto
    .content
      margin: 111px 20px 20px 180px
      width: 1166px
      .adminlist-wrapper
        background #fff
        .top
          height: 50px
          line-height: 50px
          border-bottom: 1px solid #e4e4e4
          font-size: 15px
          color: #555555
          font-weight: bold
          text-indent: 38px
          background url(./admin-icon.png) no-repeat left 10px center / 18px 18px
        .bottom
          padding: 30px 40px 25px
          overflow hidden
          .list
            float: left
            width: 100px
            margin: 0 40px 20px 0
            vertical-align top
            cursor pointer
            &:nth-child(8n)
              margin-right: 0
            .img-wrapper
              width: 100px
              height: 100px
              cursor pointer
              position relative
              &:hover .close
                display block
              .close
                position absolute
                top: 0
                right: 0
                display none
                width: 20px
                height: 20px
                background #fff url('./close.png') no-repeat center / 20px
            .text-wrapper
              text-align center
              margin-top: 10px
              .name
                font-size: 16px
                color: #000000
                height: 24px
                line-height: 24px
                font-weight: bold
                overflow hidden
                text-overflow ellipsis
                white-space nowrap
              .identity
                margin-top: 6px
                font-size: 12px
                color: #aeaeae
                height: 16px
                line-height: 16px

      .teacherlist-wrapper
        margin-top: 20px
        background #fff
        .top
          height: 50px
          line-height: 50px
          border-bottom: 1px solid #e4e4e4
          font-size: 15px
          color: #555555
          font-weight: bold
          text-indent: 38px
          background url(./teacher-icon.png) no-repeat left 10px center / 18px 18px
          .add-teacher
            margin-left: 20px
            padding:0 10px
            height: 30px
            line-height: 30px
            text-align: center
            background #3399ff
            color: #ffffff
            border-radius 4px
        .bottom
          padding: 40px
          .list
            display: inline-block
            height: 180px
            width: 530px
            margin: 0 26px 25px 0
            &:nth-child(2n)
              margin-right: 0
            .img-wrapper
              float: left
              width: 180px
              height: 180px
              position relative
              overflow hidden
              .corner
                display inline-block
                width: 55px
                height: 55px
                position absolute
                top: 0
                left: 0
                background url('./corner.png') no-repeat center / 55px 55px
            .text-wrapper
              float: left
              width: 350px
              height: 180px
              padding: 20px 20px 15px
              border: 1px solid #e4e4e4
              border-left: none
              box-sizing border-box
              position relative
              .name
                font-size: 20px
                color: #333
                height: 27px
                line-height: 27px
                font-weight: bold
                overflow hidden
                text-overflow ellipsis
                white-space nowrap
              .type
                margin: 10px 0 10px
                font-size: 12px
                color: #aeaeae
                height: 16px
                line-height: 16px
              .score
                height: 16px
                font-size: 12px
                color: #888
                .star
                  display inline-block

              .btn-wrapper
                position: absolute
                right: 20px
                top: 137px
                text-align right
                &:hover .btn:after
                  transform: rotate(135deg)
                  position relative
                  top: 2px
                  left: 8px
                .btn
                  display inline-block
                  width: 80px
                  height: 28px
                  line-height 28px
                  font-size: 12px
                  color: #999
                  box-sizing border-box
                  border: 1px solid #d7d7d7
                  border-radius 4px
                  cursor pointer
                  &:after
                    content: ' '
                    display: inline-block
                    width: 8px
                    height: 8px
                    border-left: 1px solid #333
                    border-bottom: 1px solid #333
                    transform: rotate(-45deg)
                    transition-duration 300ms
                    position relative
                    top: -2px
                    left: 8px

                .ul
                  width: 100px
                  border: 1px solid #d7d7d7
                  border-radius 4px
                  overflow hidden
                  position relative
                  top: -1px
                  .li
                    height: 35px
                    line-height 35px
                    text-align center
                    font-size: 13px
                    color: #555555
                    background #fff
                    cursor pointer
                    &:hover
                      background #f2f2f2
                    &.color
                      color: #ff6666
    .addteacher-mask
      position: fixed
      top: 0
      bottom: 0
      left: 0
      right: 0
      display: flex
      background: rgba(0, 0, 0, 0.3)
      z-index: 1000
      overflow: auto
      .addteacher
        margin: auto
        width: 420px
        padding: 30px 60px 40px
        border-radius: 4px
        background: #ffffff
        font-size: 0
        box-sizing border-box
        position relative
        .close
          position absolute
          top: 20px
          right: 20px
          cursor: pointer
        .title
          line-height: 32px
          font-size: 24px
          color: #000
          font-weight: bold
        .sub-title
          margin: 10px 0 50px 0
          font-size: 12px
          color: #ff5353
          line-height: 18px
        .explain
          font-size: 14px
          color: #333
          line-height: 18px
    .warePop
      position: fixed
      top: 0
      bottom: 0
      left: 0
      right: 0
      display: flex
      background: rgba(0, 0, 0, 0.3)
      z-index 1000
      overflow: auto
      .ware-content-wrapper
        margin: auto
        width: 720px
        padding: 30px 60px 40px
        border-radius: 4px
        background: #ffffff
        font-size: 0
        box-sizing border-box
        .ware-title
          font-size: 24px
          color: #000000
          font-weight: bold
          line-height: 40px
        .flex-wrapper
          margin: 25px 0 8px 0
          display: flex
          justify-content space-between
          .left
            font-size: 14px
            color: #000000
            line-height: 19px
          .right
            font-size: 14px
            color: #3399ff
            line-height: 19px
            cursor pointer
        .ware-wrapper
          width: 600px
          height: 450px
          padding: 20px
          border: 1px solid #e4e4e4
          box-sizing border-box
          overflow auto
          .classware
            padding: 10px 0
            border-bottom: 1px solid #e4e4e4
            .cover
              vertical-align top
            .classware-middle
              display: inline-block
              margin-left: 10px
              .title
                font-size: 14px
                color: #000000
                line-height: 22px
              .introduce
                margin-left: 22px
                width: 400px
                height: 26px
                font-size: 12px
                color: #999999
                line-height: 13px
                overflow hidden
            .del
              cursor pointer

        .ware-btn-outside
          margin-top: 40px
          height: 34px
          .ware-btn-inside
            margin: 0 auto
            width: 225px
            .cancel, .confirm
              width: 80px
              height: 34px
              line-height: 34px
              text-align: center
              font-size: 16px
              color: #ffffff
              border-radius 4px
              box-sizing border-box
            .cancel
              margin-right: 65px
              background #ccc
            .confirm
              background #3399ff

    .classpop-mask
      position: fixed
      top: 0
      bottom: 0
      left: 0
      right: 0
      display: flex
      background: rgba(0, 0, 0, 0.3)
      z-index: 1000
      overflow: auto
      .classpop
        margin: auto
        width: 1005px
        padding-left: 80px
        border-radius: 4px
        background: #ffffff
        font-size: 0
        box-sizing border-box
        .example {
          font-size: 15px
          color: #888
          overflow: hidden
          width: 850px
          margin-top: 20px
          .left {
            float: left;
            line-height: 40px
           }
          .example-area {
            float: right;
            width: 743px;
            border: 1px solid #d7d7d7
            padding: 10px
            border-radius: 10px
            p {
              font-size: 15px
              line-height: 21px
              text-align: justify
              margin-bottom: 10px
            }
          }
        }
        .title
          padding: 30px 0 50px
          line-height: 38px
          font-size: 28px
          color: #333333
          font-weight: bold
          .close
            float: right
            margin-right: 75px
            cursor pointer
        .cover-row
          margin-bottom: 12px
          height: 140px
          .left
            display: inline-block
            margin-right: 10px
            width: 75px
            height: 100%
            line-height: 100px
            font-size: 15px
            color: #888
            vertical-align: top
          .right
            display: inline-block
            .img
              vertical-align: top
            .upload-button-wrapper
              height: 30px
              margin-top: 10px
              padding-left: 10px
              .upload-button
                display: inline-block
                margin-right: 10px
                height: 30px
                line-height: 30px
                width: 90px
                text-align: center
                background: #f2f2f2
                color: #666
                font-size: 13px
                border: 1px solid #d7d7d7
                border-radius: 4px
                box-sizing border-box
                vertical-align: top
                cursor: pointer
              .hint
                display: inline-block
                width: 235px
                height: 28px
                line-height: 28px
                text-align: center
                font-size: 12px
                color: #999999
                border-radius: 4px
                border: 1px solid #ffb76e
                background: #fff9e7

        .row
          margin-bottom: 10px
          height: 35px
          .left
            display: inline-block
            margin-right: 10px
            line-height: 35px
            width: 75px
            font-size: 15px
            color: #888
          .type-select
            width: 105px
            font-size: 14px
            color: #000
            border: 1px solid #e4e4e4
            height: 35px
            -webkit-appearance: none
            -moz-appearance: none
            appearance: none
            background: #fff url('down.png') no-repeat right 9px center
            background-size: 12px 12px
            padding: 0 30px 0 6px
            border-radius: 4px
            box-sizing: border-box
          .input-name
            width: 280px
            height: 35px
            font-size: 15px
            color: #000
            padding-left: 6px
            border: 1px solid #d7d7d7
            border-radius: 4px
            box-sizing: border-box
            &::-webkit-input-placeholder
              color: #ccc
          .text
            display: inline-block
            height: 35px
            line-height: 35px
            font-size: 15px
            color: #888
        .split
          margin-bottom: 20px
          height: 10px
          width: 845px
          border-bottom: 2px dashed #d7d7d7
        .add-introduce
          width: 880px
          overflow hidden
          .left
            float: left
            margin-right: 10px
            line-height: 35px
            width: 75px
            font-size: 15px
            color: #888
          .right
            float: left
            width: 795px
            .text-wrapper
              display: flex
              align-items center
              margin-bottom: 10px
              .text
                padding: 10px
                width: 760px
                height: 100px
                font-size: 15px
                color: #000
                box-sizing border-box
                border-radius 4px
                border: 1px solid #d7d7d7
                line-height: 20px
                resize: none
              .img
                margin-left: 10px
                cursor pointer

            .img-wrapper
              display: flex
              align-items center
              justify-content space-between
              margin-bottom: 10px
              .img-left
                width: 760px
                height: 100px
                position relative
                .input
                  position: absolute
                  left: 0
                  top: 0
                  height: 100px
                  width: 100px
                  padding: 0
                  margin: 0
                  opacity: 0

            .add
              margin-right: 10px
              height: 34px
              line-height: 34px
              width: 80px
              font-size: 14px
              color: #555555
              border: 1px solid #d7d7d7
              box-sizing border-box
              border-radius 4px

        .operate-btn-wrapper
          margin: 70px 0 30px 50px
          text-align: center
          .btn
            margin-right: 65px
            width: 80px
            height: 34px
            line-height: 34px
            font-size: 16px
            color: #ffffff
            border-radius 4px
          .cancel
            background #ccc
          .confirm
            background #3399ff

</style>



// WEBPACK FOOTER //
// src/page/school/schoolmember/SchoolMember.vue